// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__oUnSY","btnClose":"Aside_btnClose__uA8Jj","btnOpen":"Aside_btnOpen__QodfZ","sublist":"Aside_sublist__yw97s","asideTitle":"Aside_asideTitle__DRg2J"};